import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "clearfix"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.timer && _ctx.timerString)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['clearfix', _ctx.cssClass])
        }, [
            (_ctx.label)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.label), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.timer.timerString), 1 /* TEXT */)
        ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true);
}
